import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var ChevronRightSmall = function ChevronRightSmall(props) {
  var rtlStyle = {
    transform: 'scale(-1, 1)'
  };
  var _props$color = props.color,
      color = _props$color === void 0 ? 'currentColor' : _props$color,
      size = props.size,
      _props$dir = props.dir,
      dir = _props$dir === void 0 ? 'ltr' : _props$dir,
      style = props.style;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: dir === 'rtl' ? _extends({}, style, rtlStyle) : _extends({}, style)
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2636 6.26361C8.91213 6.61508 8.91213 7.18493 9.26361 7.5364L13.7272 12L9.2636 16.4636C8.91213 16.8151 8.91213 17.3849 9.26361 17.7364C9.61508 18.0879 10.1849 18.0879 10.5364 17.7364L15.6364 12.6364C15.9879 12.2849 15.9879 11.715 15.6364 11.3636L10.5364 6.2636C10.1849 5.91213 9.61507 5.91213 9.2636 6.26361Z",
    fill: color
  }));
};

export { ChevronRightSmall };
